/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

var def = require('./$').setDesc
  , has = require('./$.has')
  , TAG = require('./$.wks')('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/$.set-to-string-tag.js
 ** module id = 212
 ** module chunks = 0
 **/